import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import SnippetIcon from '@material-ui/icons/Code';
import _ from 'lodash';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import CustomTableForm from '../../components/forms/CustomTables/CustomTableForm.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import OperationalView from '../../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../../components/PresentationalView/PresentationalViewHeader.jsx';
import * as CustomTablesActions from '../../redux/actions/customTables.actions';
import CustomSnippetForm from '../../components/forms/CustomTables/CustomSnippetForm.jsx';
import EmptyView from '../../components/EmptyView.jsx';
import CustomSnippetTableView from '../../components/CustomTables/CustomSnippetTableView.jsx';

let filterTimeout;

@connect(state => ({
  form: state.form.CustomTableForm,
  customSnippets: state.customTables.snippets,
  routing: state.router,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName
}))
class CustomSnippets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFieldOperationalMode: false,
      selectedField: null,
      showForm: false,
    };
  }

  onNewCustomTableButtonClicked() {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.setSelectedCustomTable({}));
    dispatch(initialize('CustomSnippetForm', {}));
    this.setState({ showForm: true });
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.setSelectedCustomTable({}));
    this.setState({ showForm: false });
  }

  onCustomTableSnippetFormSubmit(customSnippet) {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.updateCustomTableSnippetOnState(customSnippet));
  }

  onDeleteCustomSnippet(snippetId) {

  }

  onSelectCustomSnippet(snippet) {
    const { dispatch } = this.props;
    console.log(snippet);
  }

  render() {
    const { customSnippets: { content: customSnippetsData, pagination }, form, themeName, dispatch, viewLoading } = this.props;
    const { showForm } = this.state;
    const numberOfCustomTables = pagination && pagination.totalElements ? pagination.totalElements : 0;
    const canCreateItem = true;
    console.log(this.props);
    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          //onFilterChange={value => this.onSetFilter('name', _.trim(value))}
          onNewEntity={canCreateItem ? () => this.onNewCustomTableButtonClicked() : null}
          //onSearchSubmit={() => this.onFetchCustomTables()}
          //onSearchReset={() => this.onSearchReset()}
          searchGuestContainerStyle={{ width: 280 }}
          newEntityTitle="createNewCustomSnippet"
          searchPlaceholderEntityName="customTableName"
          newEntityIconName="icon-simple-line-icons-grid"
          isLoading={viewLoading}
          numberOfElements={numberOfCustomTables}
        />
        {customSnippetsData && !_.isEmpty(customSnippetsData) ? (
          <CustomSnippetTableView
            onDeleteCustomSnippet={(snippet) => this.onDeleteCustomSnippet(snippet)}
            onSelectCustomSnippet={(snippet) => this.onSelectCustomSnippet(snippet)}
          />
        ) : (
          <div style={{ marginTop: 100, marginLeft: 25 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

            <EmptyView
              title="noCustomSnippets"
              onNewEntity={() => this.onNewCustomTableButtonClicked()}
              newEntityTitle="createNewCustomSnippet"
              subtitle="startCustomSnippets"
              iconName="icon-simple-line-icons-user-following"
            />
          </div>
        </div>)}
        <OperationalView
          themeName={themeName}
          isVisible={showForm}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="snippetOperationalTitle" />}
        >
          <div style={{ paddingBottom: '10%' }}>
            <CustomSnippetForm
              onSubmit={customTableData => this.onCustomTableSnippetFormSubmit(customTableData)}
            />
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('CustomSnippetForm'))}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
}

export default CustomSnippets; 